import { routes } from "@constants/routes";
import {
  ConfirmModal,
  JobPositionGeneralInfo as JobPositionGeneralInfoCard,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationJobPositionStatusChoices } from "@graphql/generated";
import { Spinner, useDisclosure } from "@heroui/react";
import { TJobPositionData } from "@pages/JobPosition/View";
import { useNavigate, useParams } from "react-router-dom";
import { ChangeStatusModal } from "./ChangeStatusModal";

interface IJobPositionGeneralInfoProps {
  jobPosition: TJobPositionData;
  loading: boolean;
  refetch: () => void;
}

const JobPositionGeneralInfo = ({ jobPosition, loading, refetch }: IJobPositionGeneralInfoProps) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    isOpen: isStatusModalOpen,
    onOpen: onStatusModalOpen,
    onClose: onStatusModalClose,
    onOpenChange: onStatusModalOpenChange,
  } = useDisclosure();
  const { isOpen: isConfirmModalOpen, onClose: onConfirmModalClose } = useDisclosure();

  const handleOpenModal = () => {
    onStatusModalOpen();
  };

  const navigateToEdit = () => {
    if (!id) return;
    navigate(routes.jobPositions.edit?.replace(":id", id));
  };

  const handleClickEdit = () => {
    if (!id) return;
    navigate(`${routes.jobPositions.edit}?id=${id}`);
  };

  if (loading) return <Spinner size="sm" className="my-5" />;

  return (
    <>
      <ChangeStatusModal
        isOpen={isStatusModalOpen}
        onClose={onStatusModalClose}
        onOpenChange={onStatusModalOpenChange}
        status={jobPosition?.status}
        refreshData={() => {
          refetch();
        }}
      />

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={onConfirmModalClose}
        messageClassName="text-center text-base"
        message="Are you sure you want to edit job post?"
        confirmLabel="Yes"
        onConfirm={navigateToEdit}
      />

      <JobPositionGeneralInfoCard
        onClickStatus={handleOpenModal}
        jobPosition={jobPosition}
        userType={UserTypeEnum.ORG}
        onClickEdit={
          jobPosition?.status !== AuthAccountOrganizationJobPositionStatusChoices.EXPIRED && jobPosition?.isEditable
            ? handleClickEdit
            : undefined
        }
      />
    </>
  );
};

export default JobPositionGeneralInfo;
